import { render, staticRenderFns } from "./industryAnalysis.vue?vue&type=template&id=ad0b7f60&scoped=true&"
import script from "./industryAnalysis.vue?vue&type=script&lang=js&"
export * from "./industryAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./industryAnalysis.vue?vue&type=style&index=0&id=ad0b7f60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0b7f60",
  null
  
)

export default component.exports